import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Button } from 'reactstrap';
import { fetchCoursesDropdownRequest, fetchCoursesRequest, fetchTutorsRequest, addTutorRequest, getRoles } from 'store/actions';
import CreateTutor from './CreateTutor';
import Breadcrumb from 'components/Common/Breadcrumb2';
import TutorTable from './TutorTable';
import Cookies from 'js-cookie';

const TutorList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const tutors = useSelector((state) => state.Tutor.tutors);
  const courses = useSelector((state) => state.Course.courses);
  const dropdownCoursesRaw = useSelector((state) => state.Course.dropdownCourses);

  const dropdownCourses = Array.isArray(dropdownCoursesRaw)
    ? dropdownCoursesRaw
    : (dropdownCoursesRaw?.data || []);

  // console.log("coursess:",courses)
  const roles = useSelector((state) => state.Role.roles);

  const loading = useSelector((state) => state.Tutor.loading);
  const error = useSelector((state) => state.Tutor.error);

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasAddPermission = permissions?.some(item => item?.permission_name === "Add Tutor");

  useEffect(() => {
    dispatch(getRoles());
    dispatch(fetchCoursesDropdownRequest());
    console.log("[TutorList] dispatched fetchCoursesDropdownRequest()");
  }, [dispatch]);


  useEffect(() => {
    //  console.log("[TutorList] dropdownCourses (normalized) length:", dropdownCourses?.length);
  }, [dropdownCourses]);


  const handleSubmit = (data, onClose) => {
    dispatch(addTutorRequest(data, onClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Modal for creating or editing tutors */}
      <CreateTutor
        visible={isOpen}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        courses={dropdownCourses}
        roles={roles?.data?.filter(role => role?.role_name?.toLowerCase() === "tutor")}
      />

      <div className="page-content container-fluid">
        {/* Page header */}
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Tutors"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Tutors', link: '#' }
            ]}
          />

          {hasAddPermission && (
            <Button
              className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
              onClick={() => {
                dispatch(fetchCoursesDropdownRequest());
                console.log(" Dispatched fetchCoursesDropdownRequest()");
                setIsOpen(true);
              }}
            >
              <i className="ti-plus"></i> Add New
            </Button>

          )}
        </div>

        {/* Tutor list table */}
        <TutorTable
          courses={dropdownCourses}
          tutors={tutors?.data || []}
          totalrows={tutors?.total}
          loading={loading}
          error={error}
          roles={roles?.data}
        />
      </div>
    </>
  );
};

export default TutorList;
